import styles from './Body.module.scss';

const Body = ({ children }: { children: React.ReactNode }) => {
  return <main className={styles.container}>{children}</main>;
};

export default Body;
